(function () {
  function initFaq(section) {
    const items = section.querySelectorAll(".el-precise-formula__faq-item");

    function closeItem(item) {
      const trigger = item.querySelector(".el-precise-formula__faq-trigger");
      const content = item.querySelector(".el-precise-formula__faq-answer");
      if (!content) return;

      content.style.height = `${content.scrollHeight}px`;
      void content.offsetHeight;
      item.classList.remove("is-open");
      content.style.height = "0px";
      if (trigger) trigger.setAttribute("aria-expanded", "false");
    }

    function openItem(item) {
      const trigger = item.querySelector(".el-precise-formula__faq-trigger");
      const content = item.querySelector(".el-precise-formula__faq-answer");
      if (!content) return;

      item.classList.add("is-open");
      if (trigger) trigger.setAttribute("aria-expanded", "true");

      content.style.height = "auto";
      const fullHeight = content.scrollHeight;
      content.style.height = "0px";
      void content.offsetHeight;
      content.style.height = `${fullHeight}px`;
    }

    items.forEach((item) => {
      const trigger = item.querySelector(".el-precise-formula__faq-trigger");
      const content = item.querySelector(".el-precise-formula__faq-answer");

      if (!trigger || !content || item.dataset.initialized === "true") return;
      item.dataset.initialized = "true";

      content.style.height = "0px";
      content.style.overflow = "hidden";

      trigger.addEventListener("click", () => {
        const isOpen = item.classList.contains("is-open");

        items.forEach((otherItem) => {
          if (otherItem !== item && otherItem.classList.contains("is-open")) {
            closeItem(otherItem);
          }
        });

        if (isOpen) {
          closeItem(item);
          return;
        }

        openItem(item);
      });
    });
  }

  function setActiveTab(section, index) {
    const tabs = section.querySelectorAll("[data-el-formula-tab]");
    const panels = section.querySelectorAll("[data-el-formula-panel]");

    tabs.forEach((tab, i) => {
      const isActive = i === index;
      tab.classList.toggle("is-active", isActive);
      tab.setAttribute("aria-selected", isActive ? "true" : "false");
      if (isActive) {
        tab.scrollIntoView({
          behavior: "smooth",
          inline: "center",
          block: "nearest",
        });
      }
    });

    panels.forEach((panel, i) => {
      panel.classList.toggle("is-active", i === index);
    });
  }

  function initTabs(section) {
    const tabsWrap = section.querySelector("[data-el-formula-tabs]");
    const tabs = section.querySelectorAll("[data-el-formula-tab]");
    const panels = section.querySelectorAll("[data-el-formula-panel]");

    if (!tabsWrap || !tabs.length || !panels.length) return;

    setActiveTab(section, 0);

    tabs.forEach((tab, index) => {
      if (tab.dataset.initialized === "true") return;
      tab.dataset.initialized = "true";

      tab.addEventListener("click", () => {
        setActiveTab(section, index);
      });
    });
  }

  function initPreciseFormula(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll("[data-el-precise-formula]").forEach((section) => {
      initTabs(section);
      initFaq(section);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initPreciseFormula());
  } else {
    initPreciseFormula();
  }

  document.addEventListener("shopify:section:load", (event) => {
    initPreciseFormula(event.target);
  });
})();
